var _defs, _rect, _text, _text2, _g, _g2, _g3, _g4, _path, _polyline, _g5, _polyline2, _g6, _text3, _text4, _g7, _text5, _text6, _text7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOnboardingAgenticRunbooksRamp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1040 560",
    width: 1040,
    height: 560,
    role: "img",
    "aria-label": "Two time-to-productivity ramps for a new hire: a slow stepped tribal-knowledge ramp with flat blocked stretches, and a steeper agentic-runbook ramp, with the shaded gap between them labelled recovered capacity",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "rbg",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#121020"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#171523"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "rai",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8fd8f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f7fd0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "rfill",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8fd8f0",
    stopOpacity: 0.26
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8fd8f0",
    stopOpacity: 0.05
  })), /*#__PURE__*/React.createElement("style", null, "\n      .t   { font-family:'Segoe UI',Roboto,Helvetica,Arial,sans-serif; font-weight:800; fill:#efe9fa; }\n      .cap { font-family:'Segoe UI',Roboto,Helvetica,Arial,sans-serif; font-weight:700; fill:#b8b2cc; }\n      .ax  { font-family:'Segoe UI',Roboto,Helvetica,Arial,sans-serif; font-weight:600; fill:#a9a3c4; }\n      .k   { font-family:'Segoe UI',Roboto,Helvetica,Arial,sans-serif; font-weight:700; fill:#cfc3ee; }\n      .w   { font-family:'Segoe UI',Roboto,Helvetica,Arial,sans-serif; font-weight:700; fill:#f6a35a; }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1040,
    height: 560,
    rx: 18,
    fill: "url(#rbg)"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 50,
    y: 52,
    className: "t",
    fontSize: 26
  }, "Time to productivity: two ramps")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 50,
    y: 80,
    className: "cap",
    fontSize: 15
  }, "Same role, same hire. The difference is whether the knowledge is executable.")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 660,
    y1: 44,
    x2: 700,
    y2: 44,
    stroke: "#f6a35a",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 710,
    y: 49,
    className: "cap",
    fontSize: 14
  }, "Tribal knowledge ramp"), /*#__PURE__*/React.createElement("line", {
    x1: 660,
    y1: 72,
    x2: 700,
    y2: 72,
    stroke: "url(#rai)",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 710,
    y: 77,
    className: "cap",
    fontSize: 14
  }, "Agentic runbook ramp"))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    stroke: "#2a2547",
    strokeWidth: 1,
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150 130 H985 M150 205 H985 M150 280 H985 M150 355 H985"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "ax",
    fontSize: 12,
    textAnchor: "end",
    fill: "#a9a3c4"
  }, /*#__PURE__*/React.createElement("text", {
    x: 140,
    y: 134
  }, "100%"), /*#__PURE__*/React.createElement("text", {
    x: 140,
    y: 209
  }, "75%"), /*#__PURE__*/React.createElement("text", {
    x: 140,
    y: 284
  }, "50%"), /*#__PURE__*/React.createElement("text", {
    x: 140,
    y: 359
  }, "25%"))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    stroke: "#665a9c",
    strokeWidth: 1.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150 125 V430 M150 430 H985"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M150 364 L218 286 L287 232 L389 181 L492 154 L628 142 L799 136 L970 133            L970 151 L868 178 L731 232 L628 238 L526 292 L423 298 L321 352 L252 355 L150 406 Z",
    fill: "url(#rfill)"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "150,406 252,355 321,352 423,298 526,292 628,238 731,232 868,178 970,151",
    fill: "none",
    stroke: "#f6a35a",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    stroke: "#f6a35a",
    strokeWidth: 2,
    opacity: 0.55,
    strokeDasharray: "3 4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M252 340 H321 M423 283 H526 M628 223 H731"
  }))), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    points: "150,364 218,286 287,232 389,181 492,154 628,142 799,136 970,133",
    fill: "none",
    stroke: "url(#rai)",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    fill: "#9db4ff"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 287,
    cy: 232,
    r: 4.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 492,
    cy: 154,
    r: 4.5
  }))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 530,
    y: 232,
    textAnchor: "middle",
    className: "k",
    fontSize: 15
  }, "recovered capacity")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 560,
    y: 398,
    textAnchor: "middle",
    className: "w",
    fontSize: 14
  }, "flat stretches = blocked, waiting on the one person who knows")), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    className: "ax",
    fontSize: 12,
    textAnchor: "middle",
    fill: "#a9a3c4"
  }, /*#__PURE__*/React.createElement("text", {
    x: 150,
    y: 452
  }, "wk 0"), /*#__PURE__*/React.createElement("text", {
    x: 287,
    y: 452
  }, "wk 4"), /*#__PURE__*/React.createElement("text", {
    x: 423,
    y: 452
  }, "wk 8"), /*#__PURE__*/React.createElement("text", {
    x: 560,
    y: 452
  }, "wk 12"), /*#__PURE__*/React.createElement("text", {
    x: 697,
    y: 452
  }, "wk 16"), /*#__PURE__*/React.createElement("text", {
    x: 833,
    y: 452
  }, "wk 20"), /*#__PURE__*/React.createElement("text", {
    x: 970,
    y: 452
  }, "wk 24"))), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 560,
    y: 478,
    textAnchor: "middle",
    className: "cap",
    fontSize: 14
  }, "weeks since start")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 50,
    y: 512,
    className: "cap",
    fontSize: 14
  }, "Illustrative shapes, not measured data. Ramp length varies by role; plot your own two curves from your onboarding records.")), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 50,
    y: 536,
    className: "k",
    fontSize: 14,
    opacity: 0.92
  }, "A runbook that executes removes the flat stretches. That is the whole gain.")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnboardingAgenticRunbooksRamp);
export default __webpack_public_path__ + "static/media/onboarding-agentic-runbooks-ramp.c447bd6e1f0120848acab07b1f03b9fb.svg";
export { ForwardRef as ReactComponent };